<template>
    <div>
        <headC myId=3></headC>
        <navigationC name="Products"></navigationC>
        <div class="productArea">
            <div class="dropdown" v-if="shrink">
                <div class="dropdown-toggle" @click="toggleDropdown">
                    <span>{{ selectedOption || 'Select an option' }}</span>
                    <span class="icon-park-down"><i-down theme="outline" size="32" fill="#aaa" /></span>
                </div>
                <ul v-if="isOpen" class="dropdown-menu">
                    <li v-for="item in category" :key="item.id"  class="menu-item menu-item-select" >
                        <span class="over-pointer" @click="changeCategory(item.id , -1, item.name, '')" >{{item.name}}</span> 
                        <span class="right-symbol over-pointer" @click="closeSubOptions(item.id)"  v-if="item.isOpen"> 
                            <i-minus theme="outline" size="22" fill="#333" /></span>
                        <span class="right-symbol over-pointer" @click="openSubOptions(item.id)" v-if="!item.isOpen"> 
                            <i-plus theme="outline" size="22" fill="#333" /></span>
                        <ul v-if="item.isOpen" class="sub-menu-select">
                            <li v-for="subItem in item.children" :key="subItem.id" 
                            @click="changeCategory(item.id, subItem.id , item.name ,subItem.name)" class="over-pointer " >
                                <span>{{subItem.name}}</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            <div class="left-list" v-if="!shrink">
                <span class="title-span">CATEGORIES</span>

                <ul class="menu">
                    <li v-for="item in category" :key="item.id"  class="menu-item" >
                        <span class="over-pointer" @click="changeCategory(item.id , -1, item.name, '')" >{{item.name}}</span> 
                        <span class="right-symbol over-pointer" @click="closeSubMenu(item.id)" v-if="item.isOpen"> 
                            <i-minus theme="outline" size="16" fill="#333" />
                        </span>
                        <span class="right-symbol over-pointer" @click="openSubMenu(item.id)" v-if="!item.isOpen"> 
                            <i-plus theme="outline" size="16" fill="#333" />
                        </span>
                        <ul v-show="item.isOpen" class="sub-menu">
                            <li v-for="subItem in item.children" :key="subItem.id" 
                            @click="changeCategory(item.id, subItem.id , item.name ,subItem.name)" class="over-pointer" >
                                <span>{{subItem.name}}</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="right-list" :class=" shrink ? 'shirnk-width' : '' ">
                <div class="title-div" v-if="!shrink">
                    <span>{{showCategoryName}}</span>
                </div>

                <div class="product-area">
                    <div v-for="item in curList" :key="item.name" :class="shrink ? 'product-item-shrink' : 'product-item'"
                        
                        @click="goDetail(item.id)">
                        <div class="product-img-div">
                            <img :src=item.icon class="product-img" >
                        </div>
                        <span class="product-name" >{{ item.name }}</span>
                    </div>
                </div>

                
            </div>
        </div>
        <footC></footC>
    </div>

</template>
<script>
import headC from '../components/headC.vue'
import footC from '../components/footC.vue'
import navigationC from '../components/navigation.vue'
export default ({
    name: 'productsV',
    components: {
        headC,
        footC,
        navigationC,
    },
    data() {
        return {
            shrink: false,
            companyName: this.CONSTANT.companyName,
            category: this.PRODUCT.productCategory,
            productList: this.PRODUCT.productList,
            curCategory: '',
            showCategoryName: '',
            subCategory: -1,
            curList: [],
            curProduct: '',
            isOpen: false,
            selectedOption: null,

        };
    },
    watch: {
		
	},
    created(){
        
    },
    methods:{
        handleResize () {
            // 页面宽度小于840px时，调整显示内容
            this.shrink = document.documentElement.clientWidth < 920 ? true : false;
        },
        changeCategory(cateId, subCateId, name, subName){
            this.isOpen = false;
            var fullName = name;
            if(subName != ''){
                fullName = name + ' > ' + subName;
            }
            this.curCategory = cateId;
            this.subCategory = subCateId
            this.showCategoryName = fullName;
            var newList = [];
            if(this.curCategory == -1){
                this.productList.forEach((subList)=>{
                    subList.forEach((item) => {
                        item.forEach((subItem) => {
                            newList.push(subItem);	
                        })
                    })
                })
                this.curList = newList;	
                this.selectedOption = null;
            }else if(this.subCategory == -1){
                this.productList[this.curCategory].forEach((item) => {
                    item.forEach((subItem) => {
                            newList.push(subItem);	
                        })
                });
                this.curList = newList;	
                this.selectedOption = this.category[this.curCategory].name;
            }else{
                this.curList = 	this.productList[this.curCategory][this.subCategory];	
                this.selectedOption = this.category[this.curCategory].children[this.subCategory].name;
            }

        },
        readMore(name){
            this.curProduct = name;
        },
        goDetail (productId) {
            window.scrollTo(0, 0);
            this.$router.push('/products/detail/'+productId);
        },
        closeSubMenu(id){
            this.category[id].isOpen = false;	
        },
        openSubMenu(id){
            this.category[id].isOpen = true;
        },

        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        selectOption(id) {
            this.selectedOption = id;
            this.isOpen = false;
        },
        openSubOptions(id) {
            this.category[id].isOpen = true;
            //下拉列表，打开一个二级目录，就关闭其他二级目录
            // this.category.forEach((item) => {
            //     if(item.id != id){
            //         item.isOpen = false;
            //     }
            // });
            
        },
        closeSubOptions(id) {
            this.category[id].isOpen = false;
        },


    },
    mounted: function(){
        document.title= this.companyName + " | products";
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        //展示产品列表
        this.curCategory = this.$route.params.category;	
        this.subCategory = this.$route.params.subCategory;
        var subCategoryName = '';
        if(this.curCategory == -1 || this.curCategory == undefined){
            this.changeCategory(-1, -1, 'Products', '');
        }else{
            if(this.subCategory != -1){
                this.subCategoryName = this.category[this.curCategory].children[this.subCategory].name;
            }
            this.changeCategory(this.curCategory, this.subCategory, this.category[this.curCategory].name, subCategoryName);
        }
    },

})
   
</script>
<style scoped>
.productArea{
    width:100%;
}
.dropdown{
    width: 90%;
    margin-left: 3%;
    height: 50px;
    padding-top: 20px;
    margin-bottom: 40px;
    display: inline-block;
    position: relative;
    z-index: 999;
}

.dropdown-toggle{
    width: 94%;
    margin-left: 3%;
    height: 46px;
    border: 2px solid #ccc;
    cursor: pointer;
    font-size: 22px;
    line-height: 46px;
    position: relative;
    color: #555;
}
.dropdown-toggle span{
    margin-left: 10px;
}
.icon-park-down{
    float:right;
    margin-right: 10px;
    padding-top: 5px;
}


.dropdown-menu {
  list-style: none;
  padding: 0;
  margin: 0;
  border: 2px solid #ccc;
  border-top: none;
  position: absolute;
  width: 94%;
  margin-left: 3%;
  background-color: #ffffff;
}

.menu-item-select{
    padding-left: 10px !important;
    color: #555 !important;
    font-size: 22px !important;
}

.sub-menu-select{
    padding-left: 20px !important;
    font-size: 18px !important;
}


.left-list{
    width: 20%;
    margin-left: 3%;
    float: left;
}
.title-span{
    display: block;
    font-size: 20px;
    color:#333333;
    line-height: 55px;
    border-bottom: 2px solid #CCCCCC;
}


/* .menu{
    background-color: #F5F5F5;
} */
.menu-item{
    line-height: 32px;
    display: block;
    font-size: 16px;
    margin: 10px 0px;
    padding: 0px 20px 0px 0px;
    color:#333333;
}

.sub-menu{
    margin-left: 20px;
    font-size: 14px;
    color:#333333;
}

.right-list{
    width:74%;
    /* margin-right: 3%; */
    margin: 0 1.5% 0 1.5%;
    float:right;
}
.shirnk-width{
    width: 96% !important;
    margin: 0 1%  0 1%!important;

}
.title-div{
    width:97%;
    margin-left: 3%;
    font-size: 20px;
    color:#333333;
    line-height: 55px;
    border-bottom: 2px solid #CCCCCC;
    margin-bottom: 20px;
}

.product-area{
    width:100%;
    display: flex;
    flex-wrap: wrap; /* 允许换行 */
}

.product-item{
    flex: 1 1 21%;
    margin: 40px 2% 0 2%;
    position: relative;
    width: 21%;
    max-width: 21%;
    line-height: 30px;
    font-size: 20px;
    text-align: center;
    color: #333333;
    transition: all 0.5s ; 
    overflow: hidden;
}
.product-item-shrink{
    flex: 1 1 44%;
    margin: 40px 3% 0 3%;
    position: relative;
    width: 44%;
    max-width: 44%;
    line-height: 30px;
    font-size: 20px;
    text-align: center;
    color: #333333;
    transition: all 0.5s ;
    overflow: hidden;
}

.product-item:hover{
    cursor: pointer;
    /* transform: translateY(-40px); */
    /* transition: all 0.5s ;  */
}
.product-item-shrink:hover{
    cursor: pointer;
    /* transform: translateY(-40px); */
    /* transition: all 0.5s ; */
}

.product-name:hover{
    color: #007ACC;
}

.product-img-div{
    width:100%;
    margin: 0 0;
    padding: 0 0;
    overflow: hidden;
    
}

.product-img{
    width: 100%;
    display: block;
    transition: transform 0.3s ease;
}
.product-img:hover{
    transform: scale(1.2);
}

.icon-right{
    position: absolute;
    z-index: 999;
    margin: 0 auto;
    right:10px;
    top: 10px; 
}
.icon-right:hover{
    cursor: pointer;
}

ul, li {
    list-style: none;
}

.right-symbol{
    float: right;
}


</style>